import type { ConversationCreatedConversation } from '@terra/shared-dto-chat-types';
import {
  normalizeConversationTitle,
  resolveCustomConversationTitle,
} from '../components/chat/chatTabDisplayTitle';
import type { ChatTabType } from './chatTabsStore';

export function preserveCustomTitleOnConversationUpdate({
  existingTab,
  conversationId,
  serverTitle,
  defaultTitle,
}: {
  existingTab: ChatTabType | undefined;
  conversationId: string;
  serverTitle: string | null | undefined;
  defaultTitle: string;
}): Partial<ChatTabType> {
  const customTitle = resolveCustomConversationTitle({
    tab: existingTab,
  });

  return {
    conversationId,
    ...(customTitle
      ? {}
      : {
          title: normalizeConversationTitle(serverTitle) || defaultTitle,
        }),
  };
}

export function conversationForCacheWithPreservedTitle({
  existingTab,
  conversation,
}: {
  existingTab: ChatTabType | undefined;
  conversation: ConversationCreatedConversation;
}): ConversationCreatedConversation {
  const customTitle = resolveCustomConversationTitle({
    tab: existingTab,
  });

  if (!customTitle) {
    return conversation;
  }

  return {
    ...conversation,
    title: customTitle,
  };
}
